import React, { useEffect, useState } from 'react';
import { createStyles, BackgroundImage, Container, Center, Text, Box, Title, Flex, Button, Modal, useMantineTheme, SimpleGrid, Grid, Image, TextInput, LoadingOverlay, Group, AspectRatio } from '@mantine/core';
import { AnimatedSlider } from './AnimatedSlider';
import { canSendEmailCapture, markEmailCaptureSent } from './emailCaptureGuard';


const useStyles = createStyles((theme) => ({
  container: {
    // minHeight: '-moz-available',
    // minHeight: '-webkit-fill-available',
    // minHeight: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    overflow: 'hidden',
    // backgroundImage: `url('/images/pages/plicart-bg.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    background: '#221e1d',
    paddingBottom: '60px',
    '@media (min-width: 992px)': {
      height: 'calc(100vh - 20px)',
      width: '100%',
      marginBottom: '0 !important',
      paddingBottom: '0'
    },
    '@media (max-width: 991px)': {
      minHeight: 'calc(100vh - var(--navbarHeight) - var(--footerHeight) + 60px)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'flex-start',
      paddingBottom: '0',
      marginBottom: '0 !important',
      minHeight: 'calc(100vh - var(--navbarHeight) - var(--footerHeight) + 60px)',
      backgroundImage: `url('/images/ntnk-cats-bg.png')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      marginBottom: '0 !important',
      overflow: 'hidden'
    }
  },
  top: {
    '@media (max-width: 991px)': {
      padding: '45px 20px'
    }
  },
  title: {
    fontFamily: "'Albert Sans', sans-serif",
    fontSize: '60px',
    lineHeight: '70px',
    letterSpacing: '-.02em',
    color: '#fff',
    margin: '10px 0 30px',
    fontWeight: '600',
    maxWidth: '535px',
    textAlign: 'left',

    
    fontSize: '38px',
    lineHeight: '45px',
    margin: '5px 0 15px',
    
    '@media (max-width: 1400px)': {
      fontSize: '38px',
      lineHeight: '45px',
      margin: '5px 0 15px',
      color: '#fff'
    },
    
    '@media (max-width: 991px)': {
      fontSize: '28px',
      lineHeight: '32px !important',
      margin: '5px 0 15px',
      color: '#fff'
    }
  },
  second_title: {
    fontFamily: "'Albert Sans', sans-serif",
    fontSize: '28px',
    lineHeight: '45px',
    letterSpacing: '-.02em',
    color: '#999',
    margin: '10px 0 30px',
    fontWeight: '700',
    maxWidth: '535px',
    textAlign: 'left',
    
    '@media (max-width: 1400px)': {
      fontSize: '28px',
      lineHeight: '45px',
      margin: '5px 0 15px',
      color: '#999',
    },
    
    '@media (max-width: 991px)': {
      fontSize: '24px',
      lineHeight: '45px',
      margin: '5px 0 15px',
      color: '#999',
    }
  },
  modal_title: {
    fontFamily: "'Albert Sans', sans-serif",
    fontSize: '46px',
    marginRight: 'auto',
    lineHeight: '50px',
    letterSpacing: '-.02em',
    color: '#0b0b0b',
    margin: '10px 0 30px',
    fontWeight: '700',
    textAlign: 'left',
    
    '@media (max-width: 991px)': {
      fontSize: '38px',
      lineHeight: '45px',
      margin: '5px 0 15px'
    }
  },
  modal: {
    height: "800px",
    padding: "0",
    '.mantine-Modal-inner': {
      padding: '0'
    },
    '.mantine-Modal-modal': {
      padding: '0',
      backgroundColor: 'transparent',
      boxShadow: 'none'
    },

    
    '@media (min-width: 992px)': {
      height: "100vh"
    },

    
    '@media (max-width: 991px)': {
      height: "100dvh",
      padding: "0",
      '.mantine-Modal-modal': {
        padding: '0',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        height: "70vh",
        top: 'calc(50% - 70px)',
        transform: 'translateY(-50%) scale(1) !important'
      },
      '.mantine-Modal-header': {
        height: '0px',
      }
    }
  },
  flexContainer: {
    // minHeight: '-moz-available',
    // minHeight: '-webkit-fill-available',
    // minHeight: 'stretch',
    padding: '0 60px',
    margin: '0 !important',
    marginTop: '-60px',
    textAlign: 'left',
    '@media (max-width: 991px)': {
      maxWidth: '100%',
      height: '100%',
      marginBottom: '30px',
      marginTop: '0',
      position: 'relative',
      zIndex: '5',
      padding: '10px 0 0',
      display: 'flex',
      flexDirection: 'column-reverse',
      justifyContent: 'flex-start !important'
    }
  },
  modalFlexContainer: {
    // minHeight: '-moz-available',
    // minHeight: '-webkit-fill-available',
    // minHeight: 'stretch',
    padding: '0 60px',
    margin: '0 !important',
    marginTop: '-60px',
    textAlign: 'center',
    '@media (max-width: 991px)': {
      maxWidth: '100%',
      height: '100%',
      marginBottom: '30px',
      marginTop: '0',
      position: 'relative',
      zIndex: '5',
      padding: '10px 0 0',
      display: 'flex',
      flexDirection: 'column-reverse',
      justifyContent: 'flex-start !important'
    }
  },
  modal_content: {
    textAlign: 'left'
  },
  mobile_cta: {
    '@media (max-width: 991px)': {
      position: 'fixed',
      bottom: 'var(--footerHeight)',
      zIndex: '9999999999',
      width: '100vw',
      textAlign: 'center',
      opacity: 1,
      left: '0',
      transition: 'opacity .5s ease',
      maxWidth: 'none',
      borderRadius: '0 !important',
      'a': {
        width: '100%'
      },
      'button': {
        maxWidth: 'none !important',
        width: '100%',
        position: 'relative',
        'svg': {
          position: 'absolute',
          right: '30px',
          top: '50%',
          transform: 'translateY(-50%)'
        }
      },
      '&.active': {
        opacity: 1,
        transition: 'opacity .5s ease'
      }
    }
  },
  modal_container: {
    '.mantine-Modal-modal': {
      background: '#FAFAFA'
    },
    '@media (max-width: 991px)': {
      '.mantine-Modal-header': {
        marginBottom: '0px',
        position: 'absolute',
        right: '30px',
        top: '20px',
        zIndex: '10'
      }
    }
  },


  
  input: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    '.mantine-Input-wrapper': {
      width: '100%'
    },
    'input': {
      fontSize: '16px !important',
      border: '1px solid #EFEFEF',
      background: '#FFF'
    }
  },

  outer: {
    overflow: 'hidden'
  },

  swiper_outer: {
    marginBottom: '30px',
    '.swiper': {
      left: '0'
    }
  },

  swiper: {
    '@media (max-width: 991px)': {
      position: 'absolute',
      zIndex: '-1',
      opacity: '0.5',
      height: '100%'
    }
  },

  form_container: {
    '@media (max-width: 991px)': {
      margin: '0 10px'
    }
  },


  
  dropzone_container: {
    height: '100%',
    maxHeight: '165px',
    minHeight: '165px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  dropzone_outer: {
    '.mantine-Image-figure': {
      width: '100%', 
    },
    'figure': {
      height: '100%'
    },
    'img': {
      width: '100%', 
      objectFit: 'cover',
      maxHeight: '165px',
      minHeight: '165px',
      height: '165px',
    }
  },
  dropzone_button: {
    borderRadius: '80px',
    border: '1px solid #CFCFCF',
    padding: '15px 45px',
    fontSize: '16px !important'
  },
  subtext: {
    fontFamily: "'Albert Sans', sans-serif"
  },
  formInline: {
    display: 'flex',
    alignItems: 'stretch',
    gap: '12px',
    width: '100%',
    maxWidth: '520px',
    marginTop: '20px',
    '@media (max-width: 991px)': {
      flexDirection: 'column',
      maxWidth: '100%'
    }
  },
  emailInput: {
    flex: 1,
    '.mantine-Input-input': {
      height: '52px'
    }
  },
  ctaButton: {
    height: '52px',
    padding: '0 24px',
    fontWeight: 700
  },
  aspect_ratio: {
    position: 'relative',
    borderRadius: '12px',
    overflow: 'hidden',
    'figure': {
      width: '100% !important' 
    }
  }

}));

const HeaderReviewEmailOnly = ({ onOpenQuiz }) => {
  
  const { classes } = useStyles();
  const [email, setEmail] = useState('');
  const [hasTrackedTyping, setHasTrackedTyping] = useState(false);

  useEffect(() => {
    // Init gebeurt in App.js; hier alleen PageView voor deze view
    if (window.fbq && !window.location.hostname.includes('localhost') && !window.location.hostname.includes('ngrok')) {
      window.fbq('track', 'PageView');
    }
  }, []);

  const handleCTAClick = async (e) => {
    e.preventDefault();

    const isDev = window.location.hostname.includes('localhost') || window.location.hostname.includes('ngrok');
    const maySend = canSendEmailCapture(email);

    if (maySend && !isDev) {
      const payload = {
        userData: {
          email,
          name: '',
          last_name: '',
          phone: '',
          whatsappConsent: false
        },
        quizResults: null,
        aiSummary: null,
        event: 'email_capture_pre_quiz',
        timestamp: new Date().toISOString()
      };

      try {
        await fetch('https://hook.eu2.make.com/nn5x6vho9okdr4r4wezdrvldn3huxmnm', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        markEmailCaptureSent(email);
        if (window.fbq) {
          window.fbq('track', 'Lead', { content_name: 'Email pre-quiz' });
        }
      } catch (err) {
        console.error('Email capture failed', err);
      }
    }

    if (onOpenQuiz) {
      onOpenQuiz({ email });
    } else {
      // Fallback: scroll to offer section if callback not provided
      const offerSection = document.getElementById('offer');
      if (offerSection) {
        offerSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };
  
  const handleSubmit = async (e) => {
    await handleCTAClick(e);
  };

  const allTestimonials = [
    "https://via.placeholder.com/800x800",
    "https://via.placeholder.com/800x800",
    "https://via.placeholder.com/800x800",
    "https://via.placeholder.com/800x800",
    "https://via.placeholder.com/800x800",
    "https://via.placeholder.com/800x800",
    "https://via.placeholder.com/800x800",
    "https://via.placeholder.com/800x800",
    "https://via.placeholder.com/800x800",
    "https://via.placeholder.com/800x800",
    "https://via.placeholder.com/800x800",
    "https://via.placeholder.com/800x800"
  ]

  return (
    <Container className={classes.container} fluid style={{ marginBottom: '30px' }}>
      <Grid mt="0" className="header-review">
        <Flex 
          align="center"
          className={classes.flexContainer}
        >
          <Grid.Col sm={12} md={5.5} className={classes.top} mx="auto">
            <Flex 
              direction="column"
              align="start"
              pb="xl"
            >
              <Image mb="xl" src="/img/strongr-by-stef-logo-transparent.svg" height={82} width={208} alt="NTNK logo" />
              <Text fz={{ base: 'lg' }} fw={600} tt="uppercase" mb={{ base: 'lg', md: '0' }} c={'var(--red)'}>
                Resultaten gegarandeerd
              </Text>
              <Title className={classes.title} order={1} mb="md">
                Trainen zonder resultaat is verleden tijd
              </Title> 
              {/* <Title className={classes.second_title} order={1} mb="md" style={{ display: 'flex', alignItems: 'center', gap: '45px' }}>
                - met een gratis plan dat zich aanpast aan jou.
              </Title>  */}
              <Text className={classes.subtext} fz={{ base: 'md', md: 'xl' }} fw={400} mb={{ base: 'lg', md: '0' }} c={{ base: '#fff', md: '#eee' }} >
                Ontvang een gratis trainingsschema op maat dat zich aanpast aan jou en zie onmiddelijk resultaat. 
              </Text>
              <form className={classes.formInline} onSubmit={handleSubmit}>
                <TextInput
                  className={classes.emailInput}
                  placeholder="Emailadres"
                  type="email"
                  value={email}
                  onChange={(event) => {
                    setEmail(event.currentTarget.value);
                    // Track email typing started (only once)
                    if (!hasTrackedTyping && event.currentTarget.value.length > 0) {
                      setHasTrackedTyping(true);
                      const isDev = window.location.hostname.includes('localhost') || window.location.hostname.includes('ngrok');
                      if (!isDev) {
                        fetch('https://hook.eu2.make.com/tl1sygqimvdpw4jqpw9uizhzj3k3ucpa', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({ 
                            event: 'email_typing_started', 
                            page: 'goede_voornemens',
                            location: 'header_review_email_only',
                            timestamp: new Date().toISOString() 
                          })
                        }).catch(e => {
                          console.error('Webhook error:', e);
                        });
                      }
                    }
                  }}
                  required
                />
                <Button className={classes.ctaButton} type="submit" color="red">
                  Ontvang je gratis schema
                </Button>
              </form>
            </Flex>

          </Grid.Col>
          <Grid.Col sm={12} md={6} offset={.5} p="0" mr="lg">
            <Box className={ classes.swiper }>
              <AnimatedSlider testimonials={allTestimonials ? allTestimonials : null} />
            </Box> 
          </Grid.Col>
        </Flex>
      </Grid>
    </Container>
  );
}
 
export default HeaderReviewEmailOnly;